import { styled } from 'baseui';

export const SectionContainer = styled('div', {
  flex: 1,
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
});

export const RolesContainer = styled('div', {
  display: 'flex',
  boxShadow: '0px 4px 16px rgba(0, 0, 0, 0.12)',
  alignContent: 'center',
  justifyContent: 'center',
  borderRadius: '8px',
  padding: '8px',
});
